import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    CircularProgress,
    Typography,
} from "@mui/material";
import useAxios from "../../../../hooks/useAxios";
import './StudentAddClassModal.css';
import StyledTextField from '../../../common/StyledComponents/StyledTextField';
import { useNavigate } from "react-router-dom";

const StudentAddClassModal = ({ open, onClose }) => {
    const [uniqueIdentifier, setUniqueIdentifier] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const axiosInstance = useAxios();
    const [isMissingProfile, setIsMissingProfile] = useState(false);
    const navigate = useNavigate();
    const handleSubmit = async () => {
        setError(null);
        setLoading(true);
        try {
            const response = await axiosInstance.post("/classes/add-student", {
                unique_identifier: uniqueIdentifier,
            });
            if (response.data.success) {
                onClose(true); // Close modal and refresh quizzes
            } else {
                setError(response.data.message || "Failed to add quiz.");
            }
        } catch (err) {
            const errorCode = err.response?.data?.error_code;
  
            if (errorCode === "MISSING_PROFILE") {
                setIsMissingProfile(true);  // Show button to navigate to complete profile page
            }

            setError(err.response?.data?.message || "An unexpected error occurred.");
        } finally {
            setLoading(false);
            setUniqueIdentifier(null);
        }
    };

    const handleClose = () => {
        setUniqueIdentifier(null);
        onClose(false);
    };

    return (
        <Dialog open={open} onClose={() => onClose(false)} fullWidth>
            <DialogTitle className="announcement">Add a Class</DialogTitle>
            <Typography className="modal-text">Use the unique identifier provided by the class owner</Typography>
            <DialogContent>
                <StyledTextField
                    fullWidth
                    label="Unique Identifier"
                    value={uniqueIdentifier}
                    onChange={(e) => setUniqueIdentifier(e.target.value)}
                    margin="normal"
                    error={!!error}
                    helperText={error}
                />
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={handleClose} 
                    disabled={loading}
                    className="secondary-button"
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    disabled={loading || !uniqueIdentifier?.trim()}
                    startIcon={loading && <CircularProgress size={20} />}
                    className="primary-button"
                >
                    {loading ? "Adding Class" : "Submit"}
                </Button>
            </DialogActions>
            {isMissingProfile && (
                <Button
                className="my-3 mx-5" 
                onClick={() => {navigate('/setup-profile')}}
                >
                    Complete your profile now
                </Button>
            )
            }
        </Dialog>
    );
};

export default StudentAddClassModal;
